export var BACKSPACE_CODE = 'Backspace';
export var DELETE_CODE = 'Delete';
export var ARROW_LEFT_CODE = 'ArrowLeft';
export var ARROW_RIGHT_CODE = 'ArrowRight';
export var TAB_CODE = 'Tab';
export var ESC_CODE = 'Esc';
export var NAVIGATION_KEYS_CODES = [BACKSPACE_CODE, DELETE_CODE, ARROW_LEFT_CODE, ARROW_RIGHT_CODE, TAB_CODE, ESC_CODE];